module.exports = __webpack_public_path__ + "static/media/timer-collect-backing.a07af4c7.png";